{
  "tabs": {
    "chat": "Ingxoxo",
    "reminders": "Izikhumbuzo",
    "calendar": "Ikhalenda",
    "settings": "Izilungiselelo"
  },
  "common": {
    "cancel": "Khansela",
    "save": "Londoloza",
    "confirm": "Qinisekisa",
    "delete": "Susa",
    "back": "Buyela",
    "close": "Vala",
    "edit": "Hlela",
    "search": "Sesha",
    "all": "Konke",
    "loading": "Kulayishwa...",
    "error": "Kukhona okungahambi kahle",
    "notFound": "Akutholakali",
    "tryAgain": "Zama futhi",
    "retry": "Phinda uzame",
    "undo": "Buyisela",
    "pullToRefresh": "Hudula ukuze uvuselele",
    "justNow": "manje nje"
  },
  "auth": {
    "welcome": "Siyakwamukela ku FishMemory",
    "tagline": "Usizo lwakho lwezikhumbuzo zeWhatsApp, manje esikhwameni sakho.",
    "subtitle": "Usizo lwakho lwezikhumbuzo zeWhatsApp, manje esikhwameni sakho.",
    "phoneLabel": "Inombolo yakho yeWhatsApp",
    "phoneHint": "Sizokuthumelela ikhodi yokuqinisekisa ngeWhatsApp",
    "invalidPhone": "Sicela ufake inombolo yocingo evumelekile",
    "continue": "Qhubeka",
    "enterPhone": "Faka inombolo yakho yeWhatsApp",
    "phonePlaceholder": "Inombolo yocingo",
    "sendCode": "Thumela Ikhodi",
    "verifyTitle": "Qinisekisa inombolo yakho",
    "otpSentTo": "Ikhodi enezinombolo ezi-6 ithunyelwe ku {{phone}} ngeWhatsApp",
    "enterFullCode": "Sicela ufake zonke izinombolo ezi-6",
    "invalidOtp": "Ikhodi ayivumelekile. Zama futhi.",
    "otpFailed": "Kwehlulekile ukuthumela ikhodi. Zama futhi.",
    "otpResent": "Ikhodi isithunyelwe futhi",
    "resendIn": "Phinda uthumele ngemva kuka {{seconds}}s",
    "resendCode": "Phinda uthumele ikhodi",
    "enterOtp": "Faka ikhodi ethunyelwe ku WhatsApp yakho",
    "verify": "Qinisekisa",
    "resend": "Phinda uthumele ikhodi",
    "wrongNumber": "Inombolo engalungile?",
    "backToPhone": "Buyela enombolweni",
    "editPhone": "Hlela inombolo yocingo",
    "error": "Iphutha",
    "setupTitle": "Masilungise izinto",
    "setupSubtitle": "Ungahlala ushintsha lokhu kamuva ku Izilungiselelo",
    "namePlaceholder": "Igama lakho",
    "letsGo": "Qeda ukusetha",
    "skipForNow": "Gxumela okwamanje"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Thayipha umlayezo...",
    "inputPlaceholder": "Thayipha umlayezo...",
    "typing": "FishMemory uyathayipha...",
    "online": "Kuxhumekile",
    "connecting": "Kuxhuma...",
    "reconnecting": "Kuxhuma futhi...",
    "offline": "Akuhlanganisiwe",
    "empty": "Qala ingxoxo",
    "emptyHint": "Dala izikhumbuzo, hlola uhlelo lwakho, noma cela usizo.",
    "emptyAction": "Thumela isikhumbuzo sesampula",
    "actions": "Izenzo zengxoxo",
    "keep": "Gcina imilayezo",
    "clearTitle": "Sula ingxoxo",
    "clearConfirm": "Susa yonke imilayezo kule divayisi? Lokhu akungabuyiselwa.",
    "clear": "Sula ingxoxo",
    "optionSelected": "Kukhethwe: {{label}}",
    "sendingSelection": "Kuthunyelwa...",
    "connectionLost": "Kuxhuma futhi..."
  },
  "reminders": {
    "title": "Izikhumbuzo zami",
    "active": "Esebenzayo",
    "today": "Namuhla",
    "thisWeek": "Leli sonto",
    "history": "Umlando",
    "items": "izinto",
    "emptyTitle": "Azikho izikhumbuzo okwamanje",
    "emptySubtitle": "Dala esisodwa engxoxweni bese iveza lapha.",
    "emptyAction": "Vula ingxoxo",
    "filterActive": "Esebenzayo",
    "filterToday": "Namuhla",
    "filterWeek": "Leli sonto",
    "filterHistory": "Umlando",
    "emptyState": "Azikho izikhumbuzo okwamanje. Qala ukuxoxa!",
    "swipeDone": "Kwenziwe",
    "swipeSnooze": "Phumula",
    "swipeDelete": "Susa",
    "search": "Sesha izikhumbuzo...",
    "upcoming": "Ezizayo",
    "completed": "Eziphelile",
    "overdue": "Ezidlulile isikhathi",
    "tomorrow": "Kusasa",
    "synced": "Kuhambisanisiwe {{value}}",
    "swipeHint": "Hudula isikhumbuzo ukuze wenze ezinye izenzo",
    "noResults": "Azikho izikhumbuzo ezifanele ukusesha kwakho",
    "noResultsHint": "Zama igama elihlukile noma susa usesho",
    "deleteAllFailed": "Kwehlulekile ukususa zonke izikhumbuzo"
  },
  "calendar": {
    "title": "Ikhalenda",
    "today": "Namuhla",
    "tomorrow": "Kusasa",
    "completed": "kuqediwe",
    "noEvents": "Akukho okuhleliwe",
    "noEventsSubtitle": "Khetha usuku ukubona izikhumbuzo nemicimbi yekhalenda.",
    "googleEvent": "Ikhalenda ye-Google",
    "legendActive": "Esebenzayo",
    "legendRecurring": "Ephindaphindayo",
    "legendDone": "Kwenziwe",
    "legendGoogle": "Google",
    "previousMonth": "Inyanga edlule",
    "nextMonth": "Inyanga ezayo",
    "previousYear": "Unyaka odlule",
    "nextYear": "Unyaka ozayo",
    "goToToday": "Yiya namuhla",
    "all": "Konke",
    "active": "Esebenzayo",
    "done": "Kwenziwe",
    "paused": "Misiwe"
  },
  "settings": {
    "title": "Izilungiselelo",
    "profile": "Iphrofayela",
    "name": "Igama eliboniswa",
    "enterName": "Faka igama lakho",
    "language": "Ulimi",
    "uiLanguage": "Ulimi lohlelo",
    "uiLanguageHelp": "Kushintsha i-UI yohlelo, amalebula wekhalenda, nendlela yokubuka kule divayisi kuphela.",
    "serverLanguage": "Ulimi lwengxoxo",
    "serverLanguageHelp": "Kushintsha ulimi olusetshenziswa izimpendulo zeseva nemilayezo yezikhumbuzo ku-akhawunti yakho.",
    "timezone": "Isikhathi sendawo",
    "currentTimezone": "Isikhathi sendawo samanje",
    "timezoneHelp": "Zonke izikhathi zezikhumbuzo ziboniswa kusetshenziswa lesi sikhathi sendawo.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Londoloza isikhathi sendawo",
    "timezoneSaved": "Isikhathi sendawo sibuyekeziwe",
    "detect": "Thola",
    "detectFailed": "Akukwazanga ukuthola isikhathi sendawo",
    "autoDetect": "Zitholele ngokuzenzakalelayo kusuka ku-GPS",
    "notifications": "Izaziso",
    "notificationsHelp": "Izikhumbuzo eziphindaphindwayo zilawula izaziso eziphindayo emva kokulethwa kwesikhumbuzo. Imvume yezaziso kudivayisi isalawulwa kuzilungiselelo zefoni yakho.",
    "pushEnabled": "Izaziso ze-Push",
    "autoDoneOnFire": "Zimaka ngokuzenzakalelayo uma zisebenza",
    "autoDoneOnFireDesc": "Uma ivaliwe, izikhumbuzo zihlala zisebenza kuze kube usumaka njengezenziwe.",
    "googleCalendar": "Ikhalenda ye-Google",
    "google": "Ikhalenda ye-Google",
    "googleConnected": "Kuxhunywe",
    "googleDisconnected": "Akuxhunywanga",
    "googleConnectedHelp": "Izikhumbuzo ezintsha zingahambisana nekhalenda yakho ngokuzenzakalelayo.",
    "googleDisconnectedHelp": "Xhuma Ikhalenda ye-Google ukuze ugcine izikhumbuzo nemicimbi zihambisanisiwe.",
    "googleConnectFailed": "Kwehlulekile ukuxhuma Ikhalenda ye-Google",
    "connected": "Kuxhunywe",
    "disconnected": "Akuxhunywanga",
    "connect": "Xhuma",
    "disconnect": "Susa ukuxhumana",
    "autoSync": "Zihambise ngokuzenzakalelayo izikhumbuzo ezintsha",
    "autosync": "Zihambise ngokuzenzakalelayo izikhumbuzo ezintsha",
    "subscription": "Ukubhalisa",
    "trialUsed": "Isilingo: {{used}}/{{total}} sisetshenzisiwe",
    "trialStatus": "Isilingo siyatholakala",
    "activeStatus": "Ukubhalisa kusebenzayo",
    "expiredStatus": "Ukubhalisa kuphelelwe yisikhathi",
    "unsubscribedStatus": "Akubhaliswanga",
    "about": "Mayelana",
    "version": "Inguqulo",
    "logout": "Phuma",
    "logoutTitle": "Phuma",
    "logoutConfirm": "Uqinisekile ukuthi ufuna ukuphuma?",
    "noName": "Alukho igama olusethwe",
    "serverConnection": "Uxhumano lweseva",
    "serverUrl": "I-URL yeseva",
    "serverEdit": "Hlela",
    "saveReconnect": "Londoloza bese uxhuma futhi",
    "resetDefault": "Buyisela ezimweni zokuqala",
    "invalidServerUrlTitle": "I-URL yeseva ayivumelekile",
    "invalidServerUrlMessage": "Faka i-URL yeseva evumelekile ye-http noma https, isibonelo https://example.com",
    "uiLanguageChangeFailed": "Kwehlulekile ukushintsha ulimi lohlelo. Zama futhi.",
    "serverLanguageChangeFailed": "Kwehlulekile ukushintsha ulimi lwengxoxo. Zama futhi.",
    "timezoneChangeFailed": "Kwehlulekile ukushintsha isikhathi sendawo. Zama futhi.",
    "autoSyncChangeFailed": "Kwehlulekile ukubuyekeza ukuhambisana ngokuzenzakalelayo. Zama futhi.",
    "nameChangeFailed": "Kwehlulekile ukubuyekeza igama eliboniswa. Zama futhi.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Imininingwane yesikhumbuzo",
    "editTime": "Hlela Isikhathi",
    "rename": "Buyisela Igama",
    "snooze": "Phumula",
    "snooze15": "Phumula imizuzu engu-15",
    "pause": "Misa",
    "pauseReminder": "Misa isikhumbuzo",
    "resume": "Qhubeka",
    "resumeReminder": "Qhubeka nesikhumbuzo",
    "skip": "Gxumela Okulandelayo",
    "skipOccurrence": "Gxumela lesi sikhathi",
    "syncGoogle": "Harmonisa ku-Google",
    "delete": "Susa",
    "deleteTitle": "Susa Isikhumbuzo",
    "deleteConfirm": "Lesi sikhumbuzo sizosuswa unomphela.",
    "deleteRecurringTitle": "Susa Isikhumbuzo Esiphindaphindayo",
    "deleteRecurringMessage": "Ufuna yini ukugxumela lesi sikhathi noma ukususa uchungechunge lonke?",
    "deleteThisOccurrence": "Gxumela Lesi Sikhathi",
    "deleteEntireSeries": "Susa Uchungechunge Lonke",
    "done": "Kwenziwe",
    "markDone": "Marka njengekwenziwe",
    "undo": "Buyisela",
    "undoPrompt": "Uyayidinga isebenze futhi? Buyisela manje.",
    "recurring": "Ephindaphindayo",
    "nextRun": "Okulandelayo",
    "oneTime": "Isikhathi esisodwa",
    "pending": "Kulindile",
    "sent": "Kuthunyelwe",
    "paused": "Kumisiwe",
    "active": "Esebenzayo",
    "snoozed": "Kuphumule",
    "localTime": "Kubukiswa ngesikhathi sakho sendawo",
    "recurrence": "Ukuphindaphinda",
    "created": "Kudalwe",
    "tags": "Amathegi",
    "fireCount": "Izikhathi ezisebenzile",
    "actions": "Izenzo",
    "none": "Akukho",
    "snoozeFailed": "Kwehlulekile ukuphumula isikhumbuzo",
    "pauseFailed": "Kwehlulekile ukumisa isikhumbuzo",
    "resumeFailed": "Kwehlulekile ukuqhubeka nesikhumbuzo",
    "skipFailed": "Kwehlulekile ukugxumela isikhumbuzo",
    "doneFailed": "Kwehlulekile ukumaka isikhumbuzo njengekwenziwe",
    "undoFailed": "Kwehlulekile ukubuyisela isimo sesikhumbuzo",
    "deleteFailed": "Kwehlulekile ukususa isikhumbuzo",
    "rescheduleTitle": "Phinda uhlela?",
    "rescheduleMsg": "Lesi sikhumbuzo sesidlule isikhathi. Ungathanda ukusiphinda uhlela?",
    "reschedule15": "Emizuzwini engu-15",
    "reschedule60": "Ehora elilodwa",
    "keepOverdue": "Gcina njengoba kunjalo"
  },
  "onboarding": {
    "slide1Title": "Siyakwamukela ku FishMemory",
    "slide1Sub": "Usizo lwakho lomuntu siqu lwezikhumbuzo — oluqhutshwa yiWhatsApp futhi lwakhiwe esikhwameni sakho.",
    "slide2Title": "Xoxa Ngokwemvelo",
    "slide2Sub": "Thayipha izikhumbuzo ngendlela ocabanga ngayo: \"Ngikhumbuze ukushayela umama kusasa ngo-3pm\" — thina silungisa konke.",
    "slide3Title": "Ungaphuthelwa Noma Yini",
    "slide3Sub": "Thola izaziso ngesikhathi, hlela ngamathagi, futhi uhlale uphambili kukho konke okubalulekile.",
    "getStarted": "Qala",
    "next": "Okulandelayo",
    "firstReminderTitle": "Dala isikhumbuzo sakho sokuqala!",
    "firstReminderHint": "Zama ukuthayipha okuthile okufana nalokhu:",
    "firstReminderExample": "Ngikhumbuze ukuphuza amanzi kusasa ngo-9 AM",
    "gotIt": "Ngiyakuqonda!",
    "notifRationaleTitle": "Hlala Usezingeni Lesikhathi",
    "notifRationaleBody": "FishMemory idinga izaziso ukukukhumbuza ngesikhathi. Uzothola izaziso kuphela zezikhumbuzo ozidalile.",
    "notifRationaleAllow": "Vumela Izaziso",
    "notifRationaleLater": "Mhlawumbe Kamva",
    "swipeHint": "Hudula kwesokudla ukuze wenze izenzo ezisheshayo →",
    "calendarDragHint": "Hudula ukuze wandise ↕"
  }
}
